import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send, ChevronLeft, ChevronRight } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { useCentro } from "@/lib/centro";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const semana = (off) => {
  const h = new Date();
  const lun = new Date(h.getFullYear(), h.getMonth(), h.getDate() - ((h.getDay() + 6) % 7) + off * 7);
  return [iso(lun), iso(new Date(lun.getFullYear(), lun.getMonth(), lun.getDate() + 6))];
};

export const InformesEnviados = () => {
  const { centro } = useCentro();
  const [off, setOff] = useState(0);
  const [rows, setRows] = useState(null);
  const [ini, fin] = semana(off);
  useEffect(() => {
    const cargar = () => api.get("/informes-pdf/enviados", { params: { desde: ini, hasta: fin, centro } }).then((r) => setRows(r.data));
    cargar();
    window.addEventListener("informe-enviado", cargar);
    return () => window.removeEventListener("informe-enviado", cargar);
  }, [ini, fin, centro]);
  return (
    <div className="bg-white border border-emerald-200 rounded-lg p-4 fade-up" data-testid="informes-enviados">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <Send className="h-5 w-5 text-emerald-600" />
        <p className="text-sm font-semibold text-slate-800">Informes enviados {off === 0 ? "esta semana" : off === -1 ? "la semana pasada" : ""} <span className="ml-1 rounded-full bg-emerald-100 px-2 py-0.5 text-xs text-emerald-800" data-testid="informes-enviados-count">{rows?.length ?? 0}</span></p>
        <div className="ml-auto flex items-center gap-1 text-xs text-slate-600">
          <button type="button" onClick={() => setOff(off - 1)} className="rounded p-1 hover:bg-slate-100" data-testid="informes-enviados-prev"><ChevronLeft className="h-4 w-4" /></button>
          <span data-testid="informes-enviados-rango">{fmtDate(ini)} – {fmtDate(fin)}</span>
          <button type="button" onClick={() => setOff(off + 1)} disabled={off >= 0} className="rounded p-1 hover:bg-slate-100 disabled:opacity-30" data-testid="informes-enviados-next"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      {rows && !rows.length && <p className="text-xs text-slate-400">No se ha enviado ningún informe {off === 0 ? "esta semana" : "en esa semana"}.</p>}
      <div className="divide-y divide-slate-100">
        {(rows || []).map((r, i) => (
          <div key={`${r.informe_id}-${r.at}`} className="flex flex-wrap items-center gap-x-3 gap-y-0.5 py-1.5 text-xs" data-testid={`informe-enviado-${i}`}>
            <span className="w-20 font-medium text-slate-800">{fmtDate(r.at.slice(0, 10))}</span>
            <Link to={`/pacientes/${r.patient_id}`} className="min-w-[140px] flex-1 truncate text-[#1E3A8A] hover:underline">{r.paciente}</Link>
            <span className="text-slate-600">{r.to}</span>
            <span className="w-full sm:w-auto truncate text-slate-400">{[r.filename, ...r.presupuestos, ...r.adjuntos].join(" · ")}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
